import useAxios from "axios-hooks";
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { SloganSection } from "../../components";
import Api from "../../api";

import styles from "./Footer.module.scss";
import LinksSection from "./LinksSection";
import MembershipSection from "./MembershipSection";

const Footer = ({ contact }) => {
  let [{ data, loadingFtr, errorFtr }] = useAxios({ url: Api.footer_info });
  const footer_seo_text = contact && contact.city_in  ? 
  (
    contact.region ? 
    ` Проектмаркетинг+1 - Брендинговое агентство в ${contact.city_in}, ${contact.region}` 
    : 
    ` Проектмаркетинг+1 - Брендинговое агентство в ${contact.city_in} `
  ) : 
  "Проектмаркетинг+1"
  
  const manager = data && data.manager;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const links =
    data &&
    data.social_list &&
    data.social_list.map((item, index) => {
      let Link = item.split("/").length > 1 ? item.split("/")[2] : "";
      if (item.includes("max")) {
        Link = "Max";
      }
      if (item.includes("vimeo")) {
        Link = "Vimeo";
      }
      if (item.includes("vk")) {
        Link = "VK";
      }
      if (item.includes("t.me") || item.includes("telegram")) {
        Link = "Telegram";
      }
      if (item.includes("behance.net")) {
        Link = "Behance";
      }
      return (
        <a
          href={item}
          key={index}
          target="_blank"
          className={styles.FooterLink}
          rel="noreferrer"
        >
          {Link}
        </a>
      );
    });

  const navs = data && data.nav_items;

  return (
    <footer className={styles.Footer}>
      {data && (
        <div className={styles.BorderBottom}>
          <SloganSection
            title={
              <>
                Работаем над проектами
                <br /> от&nbsp;Калининграда
                <br /> до&nbsp;Хабаровска
                <div style={{ display: "none" }}>check</div>
              </>
            }
          />
        </div>
      )}

      <div className={styles.BorderBottom}>
        <div className="holder wrap no-pdn-top">
          <LinksSection
            list={navs}
            scrollToTop={scrollToTop}
            contact={contact}
            links={links}
          />
        </div>
      </div>

      <div className="holder holder_without-mobile wrap no-pdn-top">
        <MembershipSection scrollToTop={scrollToTop} />
      </div>

      <div className={classNames("holder wrap no-pdn-top", styles.ViewOnlyMobile)}>
        <div className={classNames(styles.Contacts)}>
          {contact && contact.phone && (
            <a
              href={`tel:${contact.phone}`}
              className={styles.Telephone}
              target="_self"
            >
              {contact.phone}
            </a>
          )}

          {contact && contact.email && (
            <a
              href={`mailto:${contact.email}`}
              className={styles.Email}
              target="_self"
            >
              {contact.email}
            </a>
          )}

          {links}
        </div>
      </div>

      <div className={"holder wrap no-pdn-top"}>
        <div className={classNames(styles.FooterLayout, styles.Notation)}>
          <p className={styles.Copyright}>
            © 2011–{new Date().getFullYear()},{" "}
            {footer_seo_text ? footer_seo_text : "Проектмаркетинг+1"}
          </p>

          <div>
            <Link to="/pages/privacy-policy" className={styles.PrivacyPolicy}>
              Политика конфиденциальности
            </Link>

            <br />

            <Link to="/sitemap" className={styles.Sitemap}>
              Карта сайта
            </Link>
          </div>

          <a
            href="https://a-teleport.ru/"
            target="_blank"
            className={styles.SEO}
            rel="noreferrer"
          >
            Продвижение сайта — teleport
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
